<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.withdrawal')"></NavbarSimple>
      <div class="wrapper">
          <span>{{$t('withdrawalPage.text1')}}</span>
          <span class="text2">{{$t('withdrawalPage.text2')}}</span>
          <div class="balance">
              {{availableBalance}}
          </div>
          <span>{{$t("withdrawalPage.dailyWithdrawalLimit")}}:
              <span class="quota">{{$t("withdrawalPage.unlimit")}}</span>
        </span>
          <div class="form">
            <select v-model="formObj.walletType" class="field">
                <option :value ="1">{{$t("common.investWallet")}}</option>
                <option :value ="2">{{$t("common.financialWallet")}}</option>
                <option :value="3">{{$t("common.promotionWallet")}}</option>
            </select>
            <select v-if="formObj.walletType === 1" v-model="formObj.orderType" class="field">
                <option value ="principalBalance">{{$t("common.withdrawalPrincipal")}}</option>
                <option value ="profitBalance">{{$t("common.withdrawalProfit")}}</option>
            </select>
            <input v-model="formObj.amount" type="number" min="1" class="field">
            <input v-model="formObj.toAddress" type="text" class="field" :placeholder="$t('common.toAddress')" disabled>
            <span class="fee">{{$t('common.serviceFee')}}: {{data.serviceFee}} usdt</span>
            <van-button round color="#4A3933" block @click="submit" style="margin-top:2rem;" :disabled="submitting">{{ $t("common.confirm") }}</van-button>
          </div>
      </div>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'withdrawal',
    components: {
        NavbarSimple
    },
    data() {
        return {
            formObj: {
                walletType: 1,
                orderType: 'principalBalance',
                amount: 0,
                toAddress: localStorage.getItem('addr'),
            },
            data: {
                wallets: [],
                serviceFee: 0,
                withdrawPermission: true
            },
            submitting: false
        }
    },
    mounted() {
        this.token = localStorage.getItem('token');
        this._fetch();
    },
    methods: {
        _fetch() {
            this.apiV1({
                method: 'get',
                url: '/withdraw/page',
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                    this.data = data;
                }
            });
        },
        submit() {
            if (!this.data.withdrawPermission) {
                this.$dialog.alert({
                    title: this.$t('common.tips'),
                    message: this.$t('common.Withdrawals_prohibited'),
                    confirmButtonText: this.$t('common.confirm')
                });
                return;
            }
            try {
                this.submitting = true;
                if (Number.parseFloat(this.data.serviceFee) >= this.formObj.amount) {
                    this.$toast.fail(this.$t("common.minWithdrawalError"));
                    return;
                }
                if (this.formObj.amount && this.formObj.toAddress) {
                    this.apiV1({
                        method: 'post',
                        url: '/withdraw',
                        data: this.formObj,
                        headers: {'Authorization': this.token}
                    }).then(response => {
                        const { success } = response.data;
                        if (success) {
                            this.$toast.success(this.$t("common.submitted"));
                            this._fetch();
                        }
                    });
                } else {
                    if (!this.formObj.amount || this.formObj.amount < 1) {
                        this.$notify({ type: 'danger', message: 'Withdrawal amount required.' });
                        return
                    }
                    if (!this.formObj.toAddress) {
                        this.$notify({ type: 'danger', message: 'Tron wallet address required.' });
                        return
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.submitting = false;
            }
        }
    },
    computed: {
        availableBalance() {
            const wallet = this.data.wallets.find(elem => elem.type === this.formObj.walletType);
            if (wallet) {
                if (wallet.type !== 1) {
                    return wallet.integral;
                } else if (this.formObj.orderType === 'principalBalance') {
                    return wallet.principalBalance;
                } else {
                    return wallet.profitBalance;
                }
            }
            return 0;
        }
    }
}
</script>

<style scoped lang="less">
.wrapper {
    margin-top: 4rem;
    padding: 5.333rem;
    font-size: 3.467rem;
    // color: #fff;
    background-color: @app-theme-color4;
    border: 0.267rem solid @app-theme-color1;
    border-radius: 5.333rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    .text2, .quota {
        color: @app-theme-color3;
    }
    .balance {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #d6b593;
        border: 0.267rem solid @app-theme-color1;
        font-size: 10.667rem;
        height: 24rem;
        border-radius: 5.333rem;
        margin: 2.4rem 0;
    }
    .form {
        margin-top: 5.333rem;
        display: flex;
        flex-direction: column;
        .field {
            height: 8.533rem;
            font-size: 4.267rem;
            border-radius: 4rem;
            border: 0.267rem solid @app-theme-color1;
            background-color: #fff;
            padding-left: 2rem;
        }
        .field + .field, .fee {
            margin-top: 4rem;
        }
        .fee {
            // text-align: left;
            // margin-bottom: 2rem;
            color: @app-theme-color3;
        }

    }
}
</style>